var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#565C65","fillRule":"evenodd","d":"M9.941.444v4.512h-2.84c-.444 0-.71.258-.71.752v2.254l3.55.001-.71 4.511H6.39V23H2.15l-.001-10.527L0 12.474v-4.51l2.149-.002V4.846c.005-.89.162-4.254 4.25-4.397l.272-.005h3.27z"}));
}

Facebook.defaultProps = {"width":"10","height":"23","viewBox":"0 0 10 23"};

module.exports = Facebook;

Facebook.default = Facebook;
